const state = {
  addressId: '', // 支付地址
  payType: '', // 支付方式 cart 购物车结算 buyNow 立即购买结算
  payInfo: [], // 支付信息
  cartInfo: {}, // key 是 goods_sn, value 是 cart_id
  movieInfo: {}, // 电影信息
  goodsType: '', // 商品类型
  paymentType: {
    // 支付类型
    cart: 'cart',
    buyNow: 'buyNow'
  },
  // 福利卡信息
  welfareCard: {},
  orderId: '', // 订单号
  // 支付方式
  payWay: {
    saas: [], // saas支付方式 积分| 余额| 优惠劵
    cansh: [] // 现金支付方式 微信 | 支付宝 | 银联
  },
  address: {},
  addressInfo: {},
  /*
    已通过服务端校验的地址 id.
    这里保持初始空值, 缓存由 HYDRATE_ADDRESS 显式注入 ——
    若在此处直接读缓存, 会被 store/index.js 的 _initState 快照固化,
    退出登录后 RESET_ALL_STATE 又把上一个用户的地址还原回来.
  */
  validatedAddressId: '',
  cakeShop: {}, // 蛋糕门店
  cakeDelivery: ''
}

export default state
